module.exports = __webpack_public_path__ + "img/icons8_amazon_prime_video.29f7dc27.svg";